import SelectorEngine from '../../utils/dom/selector-engine';
import { startLoadingAnimation, stopLoadingAnimation } from '../../utils/dom/loading';
import Request from '../../utils/request';

class mandatoryFairPlayVideo {
	constructor() {
        this.wrapper = SelectorEngine.findOne('.p-mandatory-watch-video');
        if(this.wrapper) {
            this.init();
        }
    }

    init() {
        this.video = SelectorEngine.findOne('lite-video', this.wrapper);
        this.button = SelectorEngine.findOne('.lta-video-embed__mandatory-btn', this.wrapper);
        if (!this.video || !this.button) {
            return;
        }
        this.errorContainer = SelectorEngine.findOne('.p-mandatory-watch-video__error-container', this.wrapper);
        this.errorButton = SelectorEngine.findOne('.js-dismiss-error',this.errorContainer)
        this.button.disabled = true;
        this.video.addEventListener('mandatory-video-completed',this.handleVideoCompleted.bind(this));
        this.errorButton.addEventListener('click', () => {
			this.errorContainer.classList.add('u-hidden');
		});
    }

    handleVideoCompleted(event) {
        this.videoData = event.detail;
        this.button.disabled = false;
        this.button.addEventListener('click',this.submit.bind(this));
    }

    async submit() {
        try {
            startLoadingAnimation();
            const response = await Request.post(this.button.dataset.api, this.videoData);
            const {success,redirectUrl} = response;
            if (success && redirectUrl) {
                window.location.href = redirectUrl;
            }
        } catch (error) {
            this.errorContainer.classList.remove('u-hidden');
        } finally {
            stopLoadingAnimation();
        }
    }
}

const globalMyResources = new mandatoryFairPlayVideo();
export default globalMyResources;
